import { atom } from "recoil";

export const subjectState = atom({
  key: "subjectState", // unique ID (with respect to other atoms/selectors)
  default: "", // default value (aka initial value)
});
